




















































































import Element from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { RspbltyData, emptyRspblty, UserTeamData } from '@/api/systemManage/user'
import { validateIntKey, validatePhone } from '@/configs/validate'
import { DDLItem, getLookupByType } from '@/api/common/select'
import { enLookupType, enFirstType } from '@/configs/enums'
import ModifyCruiseTeam from '@/components/cruiseTeam/modify.vue'
import { CruiseTeamData } from '@/api/cruiseTeam'
const validateTeamList = (rule: any, value: any, callback: (error?: Error) => void) => {
  if (!rule.formInfo.TeamList || rule.formInfo.TeamList.length == 0) {
    callback(new Error('请选择巡防组织'))
  } else {
    callback()
  }
}
const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    // BirthDate: [{ required: true, message: '请选择出生年月', trigger: 'blur' }],
    // CruiseTeamId: [{ required: true, validator: validateIntKey('请选择巡防组织'), trigger: 'change' }],
    TeamList: [{ required: true, validator: validateTeamList, formInfo: form, trigger: 'change', message: '请选择巡防组织' }],
    ContactorPhone: [
      // { required: true, message: '手机不能为空', trigger: 'blur' },
      { validator: validatePhone, trigger: 'blur' }
    ]
  }
}

@Component({
  components: {
    ModifyCruiseTeam
  }
})
export default class RspbltyInfo extends Vue {
  public name: string = 'RspbltyInfo'

  @Prop({ default: false })
  public readonly: boolean = false

  public form: RspbltyData = Object.assign({}, emptyRspblty)

  public ddlFirstType = enFirstType.None
  public rules: any = getFormRules(0, this.form)
  public cruiseTeamList: DDLItem[] = []
  public get selectedTeams(): number[] {
    const f = this.form
    const vals = f.TeamList.map((data: UserTeamData) => {
      return data.TeamId
    })
    return vals
  }
  public set selectedTeams(vals: number[]) {
    const f = this.form
    const objs: UserTeamData[] = vals.map((data: number) => {
      return {
        Id: 0,
        UserId: f.UserId,
        TeamId: data,
        TeamName: ''
      }
    })
    f.TeamList = objs
  }
  // dynamic component
  public $refs!: {
    rspbltyForm: Element.Form
    modifyTeamCtrl: ModifyCruiseTeam
  }
  public mounted() {
    //审核结束后回调函数
    window.eventBus.$on('submitCruiseTeamModify', (data: CruiseTeamData) => {
      var newItem: DDLItem = {
        Key: data.Id,
        Val: data.ItemValue,
        ExInfo: {
          Code: data.ItemCode,
          Flag1: false,
          Flag2: false,
          Explain: data.Comments
        },
        SubList: []
      }
      this.cruiseTeamList.unshift(newItem)
      this.form.TeamList.push({ TeamId: data.Id, TeamName: data.ItemValue, UserId: 0, Id: 0 })
      // this.cruiseTeamList= []
      // this.featchSource()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitCruiseTeamModify')
  }
  public teamAdd() {
    window.eventBus.$emit('openCruiseTeamModify', 0)
  }
  public setData(info: RspbltyData) {
    if (info.Id > 0 || (info.TeamList && info.TeamList.length > 0)) {
      this.form = info
    }
    if (this.readonly) {
      this.rules = []
      this.ddlFirstType = enFirstType.None
    } else {
      this.rules = getFormRules(this.form.Id, this.form)
      if (this.form.Id == 0 || this.readonly) {
        this.$nextTick(() => {
          if (this.$refs.rspbltyForm) {
            this.$refs.rspbltyForm.clearValidate()
          }
        })
      }
    }

    console.log('get', this.form)
    this.featchSource()
  }
  public featchSource() {
    if (this.cruiseTeamList.length == 0) {
      getLookupByType(enLookupType.CruiseTeam, this.ddlFirstType).then(
        (response: { data: any }) => {
          this.cruiseTeamList = response.data
        }
      )
    }
  }
  public getData() {
    return this.form
  }
  public getForm() {
    return this.$refs.rspbltyForm
  }
}
